import TranslationTableBuilder from "../controllers/Settings/TranslationTableDetails";
import { rows } from "colbi_web_ui/lib/components";
import TranslationTableDetailsManagement from "../components/TranslationTableDetailsManagement/TranslationTableDetailsManagement.js";
import { getConfigVariable } from "../config/config";

const queries = (args) => {
    return [
        {
            resource: "translation_builder",
            args: {
                translationId: `${args.id}`,
                page: parseInt(args.page, 10) || 0,
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
            },
            body: "__typename,items{translationId,id,conditions,updates}, total, hasMore",
            isDatagridReq: true,
        },
        {
            resource: "translation_builder_fields",
            args: {
                translationId: `${args.id}`,
            },
            body: "__typename, entity, cdmNames, cdmEntity, datasetLocale",
        },
    ].filter((q) => q);
};

const translationTableDetails = (path, navigation, exact, title) => ({
    path,
    navigation,
    component: TranslationTableBuilder,
    exact,
    queries,
    title: [title],
    components: [
        {
            component: TranslationTableDetailsManagement,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).list",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: "query(0).showCheckbox",
                total: "query(0).metadata.total",
                hideDeleteSeriesButton: true,
                entity: "query(1).entity",
                cdmEntity: "query(1).cdmEntity",
                cdmNames: "query(1).cdmNames",
                datasetLocale: "query(1).datasetLocale",
            },
        },
    ],
});

export default translationTableDetails;
